import React from "react";
import PropTypes from "prop-types";

const BerryCheckIcon = ({ size = 64, className = "" }) => (
  <div
    className={`berry-check-icon ${className}`.trim()}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <svg width={size * 0.45} height={size * 0.45} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 12.5L10 17.5L19 7.5"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

BerryCheckIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default BerryCheckIcon;
